import moment from 'moment'
import React, { useEffect, useMemo, useState } from 'react'
import { loadEditor } from '@Components/RichTextAnswer/RichTextAnswer'
import AssignmentAnswer from './AssignmentAnswer'
import AssignmentContent from './AssignmentContent'

type Props = {
	assignment: AssignmentUnit
	submission: AssignmentSubmission | null
}
const Assignment: React.VoidFunctionComponent<Props> = ({ assignment, submission }) => {
	// Edit mode is owned here, derived from the submission: a fresh unit opens
	// in edit mode (the chooser, or the locked answer form, is shown straight
	// away), a submitted one opens read-only until Edit is clicked. The old
	// mount effect forced `false` and ran AFTER the child's attempt to open a
	// locked-type form, leaving those assignments with no editor and no Submit.
	const [isEdit, setIsEdit] = useState(!submission)
	useEffect(() => {
		setIsEdit(!submission)
	}, [assignment.id, submission?.id])

	const canSubmitAnswer = useMemo(() => {
		// `deadline_at` is the backend's own instant (creation + duration days),
		// the same one it enforces; null means no deadline.
		if (!assignment.deadline_at) return true
		return moment().isBefore(moment(assignment.deadline_at))
	}, [assignment])

	// Warm the rich answer editor chunk while the student reads the question.
	useEffect(() => {
		if (assignment.answer_schema !== 'attachment') loadEditor().catch(() => {})
	}, [assignment.answer_schema])

	return (
		<>
			<AssignmentContent
				canSubmit={canSubmitAnswer}
				assignment={assignment}
				submission={submission}
				onEditClick={() => setIsEdit(true)}
				isEdit={isEdit}
			/>
			<AssignmentAnswer
				onChooseType={setIsEdit}
				canSubmit={canSubmitAnswer}
				assignment={assignment}
				submission={submission}
				setIsEdit={setIsEdit}
				isEdit={isEdit}
			/>
		</>
	)
}

export default Assignment
